// extracted by mini-css-extract-plugin
export var chatHtmlText = "_m8-2";
export var chatLink = "_m8-0";
export var chatText = "_m8-1";